import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'uk', label: 'Українська' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (e, code) => {
    e.preventDefault();
    i18n.changeLanguage(code);
    window.location.reload();
  };

  const current = LANGUAGES.find(l => i18n.language.startsWith(l.code)) || LANGUAGES[0];

  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <a href="#none" className="header-widget-icon" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <i className="icon-feather-globe"></i>
        <span style={{ fontSize: '13px', fontWeight: '500', textTransform: 'uppercase' }}>{current.code}</span>
      </a>
      <div uk-dropdown="pos: bottom-right; mode: click; offset: 6" className="dropdown-notifications small" style={{ minWidth: '130px' }}>
        <ul className="dropdown-user-menu">
          {LANGUAGES.map(lang => (
            <li key={lang.code}>
              <a
                href="/"
                onClick={(e) => changeLanguage(e, lang.code)}
                style={{ fontWeight: i18n.language.startsWith(lang.code) ? '700' : 'normal' }}
              >
                {lang.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LanguageSelector;
